"use client"

import React, {useEffect, useRef, useState} from 'react';
import {InputLogin} from "@/components/tailwindComponents/input-fields/input-login";
import {FieldValues, useForm} from "react-hook-form";
import {EyeIcon, EyeSlashIcon} from "@heroicons/react/24/solid";
import {FORGET_PASSWORD} from "@/services/Api";
// import ErrorHandler from "@/components/utils/ErrorHandler";
import {AxiosError} from "axios";
import Spinner from "@/components/tailwindComponents/Spinner";
import DisplayError from "@/components/handlers/ErrorHandler";
import {toast} from "react-toastify";
import {OTP_TIMER} from "@/constants";
import Timer from "@/components/utils/Timer";
import {ArrowLeftIcon} from "@heroicons/react/24/outline";

const ForgetPassword = ({setShowForgetPassword}: {
    // setForgetPasswordError: AxiosError | string | null,
    setShowForgetPassword: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    let steps = ["شماره موبایل", "کد تایید", "تغییر رمز"];
    const [activeStep, setActiveStep] = useState(0);
    const {
        register,
        setValue,
        setError,
        clearErrors,
        watch,
        getValues,
        formState: {errors}
    } = useForm<FieldValues>();
    const [formError, setFormError] = useState<AxiosError | null>(null);
    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const [otpLoadingButton, setOtpLoadingButton] = useState<boolean>(false);
    const [timeLeft, setTimeLeft] = useState<number>(0);

    const endTimeRef = useRef<number | null>(null);

    const mobileNumber = watch("mobile");
    const code = watch("code")
    const password = watch("password")
    const confirm_password = watch("confirm_password")

    // Eye icons for password
    const renderIcon = (isVisible: boolean, toggle: () => void) => (
        <button
            type="button"
            onClick={toggle}
            className="absolute top-0 bottom-0 right-3 flex items-center text-gray-500"
        >
            {isVisible ? <EyeIcon className="h-5 w-5"/> : <EyeSlashIcon className="h-5 w-5"/>}
        </button>
    );

    useEffect(() => {
        clearErrors()
        setFormError(null)
    }, [mobileNumber, code, password, confirm_password]);

    useEffect(() => {
        if (activeStep === 1 || activeStep === 2) {
            if (!endTimeRef.current) {
                endTimeRef.current = Date.now() + OTP_TIMER * 1000;
            }

            // همینجا مقدار اولیه timeLeft رو ست کن
            const now = Date.now();
            const remaining = Math.max(Math.floor((endTimeRef.current - now) / 1000), 0);
            setTimeLeft(remaining);

            const timer = setInterval(() => {
                const now = Date.now();
                const remaining = Math.max(Math.floor((endTimeRef.current! - now) / 1000), 0);
                setTimeLeft(remaining);

                if (remaining === 0) {
                    clearInterval(timer);
                    setLoadingButton(false);
                }
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [activeStep, endTimeRef.current]);

    useEffect(() => {
        return () => {
            endTimeRef.current = null;
        };
    }, []);

    const handleNext = async (e: React.FormEvent): Promise<void> => {
        if (activeStep === 0) {
            try {
                setLoadingButton(true);
                const code = await FORGET_PASSWORD.CODE(mobileNumber)
                if (code) {
                    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
                } else {
                    console.log('code doesnt exist')
                }
            } catch (e) {
                if (e instanceof AxiosError) {
                    setFormError(e);
                } else {
                    setFormError(null);
                }
                console.error("Unexpected error:", e);
            } finally {
                setLoadingButton(false);
            }
        } else if (activeStep === 1) {
            try {
                setLoadingButton(true);
                const checkCode = await FORGET_PASSWORD.CHECK_CODE(mobileNumber, code)
                if (checkCode) {
                    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
                }
            } catch (e) {
                if (e instanceof AxiosError) {
                    setFormError(e);
                } else {
                    setFormError(null);
                }
                console.error("Unexpected error:", e);
            } finally {
                setLoadingButton(false);
            }
        } else if (activeStep === 2) {
            try {
                setLoadingButton(true);
                const changePassword = await FORGET_PASSWORD.CHANGE(mobileNumber, code, password, confirm_password)
                if (changePassword) {
                    setShowForgetPassword(false);
                    toast.success("تغییر رمز با موفقیت انجام شد.");
                }
            } catch (e) {
                if (e instanceof AxiosError) {
                    setFormError(e);
                } else {
                    setFormError(null);
                }
                console.error("Unexpected error:", e);
            } finally {
                setLoadingButton(false);
            }
        } else {
            return;
        }
    };

    const getNewOtp = async (e: React.FormEvent): Promise<void> => {
        e.preventDefault();
        setValue("code", "");
        if (activeStep === 2) setActiveStep(1)
        try {
            setOtpLoadingButton(true);
            endTimeRef.current = Date.now() + OTP_TIMER * 1000;
            const resend = await FORGET_PASSWORD.CODE(mobileNumber);
            if (resend) {
                toast.success("کد مجدد ارسال شد.");
                setTimeLeft(OTP_TIMER);
            } else {
                toast.error("ارسال مجدد کد با مشکل مواجه شد.");
            }
        } catch (e) {
            if (e instanceof AxiosError) {
                setFormError(e);
            } else {
                setFormError(null);
            }
            console.error("خطا در ارسال مجدد کد:", e);
        } finally {
            setOtpLoadingButton(false);
        }
    };

    return (
        <div>
            {errors && <DisplayError error={formError} setError={setError} getValues={getValues as never}/>}
            <div className="flex flex-col justify-center gap-8">
                <div className="flex items-center justify-center">
                    {steps.map((step, index) => (
                        <div key={index} className="flex items-center">
                            <div
                                className={`
              w-20 h-8 rounded-full flex items-center justify-center
              ${
                                    index === activeStep
                                        ? 'bg-blue-500 text-white'
                                        : index < activeStep
                                            ? 'bg-green-500 text-white'
                                            : 'bg-gray-300 text-gray-600'
                                }
            `}
                            >
                                {index < activeStep ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                ) : (
                                    <span className="text-xs">{step}</span>
                                )}
                            </div>
                            {index < steps.length - 1 && (
                                <div
                                    className={`
                h-1 w-12
                ${
                                        index < activeStep
                                            ? 'bg-green-500'
                                            : 'bg-gray-300'
                                    }
              `}
                                ></div>
                            )}
                        </div>
                    ))}
                </div>
                <div>
                    {activeStep === 0 && (
                        // <form onSubmit={submitMobileNumber}>
                        <InputLogin
                            name="mobile"
                            label={
                                <p>
                                    شماره موبایل
                                </p>
                            }
                            type="text"
                            dir="ltr"
                            // prefix="+98"
                            register={register('mobile')}
                            error={errors.mobile?.message as string}
                        />
                        // </form>
                    )}
                    {activeStep === 1 && (
                        <div>
                            <InputLogin
                                name="code"
                                label={
                                    <p>
                                        کد احراز
                                    </p>
                                }
                                type="text"
                                dir="ltr"
                                register={register('code', {
                                    required: 'کد احراز الزامی است',
                                })}
                                error={errors.code?.message as string}
                            />
                            {timeLeft > 0 && (
                                <div className="col-span-1 flex items-center justify-end">
                                    <Timer timeLeft={timeLeft}/>
                                </div>
                            )}
                        </div>
                    )}
                    {activeStep === 2 && (
                        <div>
                            <InputLogin
                                name="password"
                                label="رمز عبور"
                                type="password"
                                dir="ltr"
                                register={register('password', {required: 'رمز عبور الزامی است'})}
                                error={errors.password?.message as string}
                                icon={renderIcon}
                                required={true}
                            />
                            <InputLogin
                                name="confirm_password"
                                label="تکرار رمز عبور"
                                type="password"
                                dir="ltr"
                                register={register('confirm_password', {required: 'تکرار رمز عبور الزامی است'})}
                                error={errors.confirm_password?.message as string}
                                icon={renderIcon}
                                required={true}
                            />
                            {timeLeft > 0 && (
                                <div className="col-span-1 flex items-center justify-end">
                                    <Timer timeLeft={timeLeft}/>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {/*<div className="w-full justify-center">*/}
                {activeStep === 2 ? (
                    <div className="flex flex-col w-full">
                        {activeStep > 0 && endTimeRef.current && timeLeft === 0 && (
                            <button
                                onClick={getNewOtp}
                                className="flex justify-center p-2 rounded-lg bg-orange-200 shadow-md text-black  hover:bg-black hover:text-white">
                                {otpLoadingButton ? <Spinner className="size-6"/> : "ارسال مجدد کد"}
                            </button>
                        )}
                        <button
                            onClick={handleNext}
                            disabled={activeStep > 0 && timeLeft === 0}
                            className="flex justify-center my-4 p-2 rounded-lg bg-primary shadow-md text-white  hover:bg-black hover:text-white disabled:bg-gray-500">
                            {loadingButton ? <Spinner className="size-6"/> : "ثبت و انتقال به صفحه ورود"}
                        </button>
                    </div>
                ) : (
                    <div className="flex flex-col w-full">
                        {activeStep > 0 && endTimeRef.current && timeLeft === 0 && (
                            <button
                                onClick={getNewOtp}
                                className="flex justify-center p-2 rounded-lg bg-orange-200 shadow-md text-black  hover:bg-black hover:text-white">
                                {otpLoadingButton ? <Spinner className="size-6"/> : "ارسال مجدد کد"}
                            </button>
                        )}
                        <button
                            onClick={handleNext}
                            // disabled={activeStep > 0 && timeLeft === 0}
                            className="flex justify-center my-4 p-2 rounded-lg bg-primary shadow-md text-white  hover:bg-black hover:text-white disabled:bg-gray-500 hover:cursor-pointer">
                            {loadingButton ? <Spinner className="size-6"/> : "بعدی"}
                        </button>
                        <div className="flex w-full justify-end my-3">
                            <p className="inline-flex items-center gap-x-1.5 py-1 px-2 text-xs text-primary border border-primary hover:cursor-pointer hover:text-white hover:bg-black rounded-md"
                               onClick={() => setShowForgetPassword(false)}
                            >
                            <span
                            >
                                بازگشت به صفحه لاگین
                            </span>
                                <ArrowLeftIcon className="size-3"/>
                            </p>
                        </div>
                    </div>
                )}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default ForgetPassword;